import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import { getCircular } from "../Service/Api";

const Magazine = () => {
  const [allMagazines, setAllMagazines] = useState([]);
  const [magazineData, setMagazineData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [yearRanges, setYearRanges] = useState([]);

  useEffect(() => {
    document.title = "Magazine - Hill Top School, Jamshedpur";
    fetchMagazine();
  }, []);

  const fetchMagazine = async () => {
    try {
      const data = await getCircular();

      // Add year safely from date
      const magazinesWithYear = data.map((item) => ({
        ...item,
        sessionYear: item.date ? item.date.split("-")[0] : "",
      }));

      setAllMagazines(magazinesWithYear);

      // Get unique years (latest first)
      const years = [
        ...new Set(magazinesWithYear.map((item) => item.sessionYear)),
      ]
        .filter(Boolean)
        .sort((a, b) => b.localeCompare(a));

      setYearRanges(years);

      const latestYear = years[0] || "";
      setSelectedYear(latestYear);

      const filtered = magazinesWithYear.filter(
        (item) => item.sessionYear === latestYear
      );

      setMagazineData(filtered);
    } catch (error) {
      console.error("Error fetching magazine:", error);
    }
  };

  const handleYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    const filtered = allMagazines.filter(
      (item) => item.sessionYear === year
    );

    setMagazineData(filtered);
  };

  return (
    <>
      <Header />

      {/* Breadcrumb */}
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>Gallery</li>
          <li>Magazine</li>
        </ul>
      </div>

      <div className="innersec">
        <div className="container">

          {/* Title */}
          <div className="row">
            <div className="col-lg-12">
              <h1>Magazine</h1>
            </div>
          </div>

          {/* Year Filter */}
          <div className="row my-3 justify-content-center">
            <div className="col-md-4">
              <select
                className="form-select text-center"
                value={selectedYear}
                onChange={handleYearChange}
              >
                <option value="">Select Year</option>
                {yearRanges.map((yr, idx) => (
                  <option key={idx} value={yr}>
                    {yr}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Magazine Cards */}
          <div className="row">
            {magazineData.length > 0 ? (
              magazineData.map((item, index) => (
                <div className="col-lg-4 col-md-6 col-12" key={index}>
                  <div className="syllabus-card text-center p-4 border rounded shadow-sm h-100 d-flex flex-column justify-content-between">

                    {/* Image */}
                    <div className="lazyload-wrapper">
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/HTSJ/public/Images/circular.png"
                        alt={item.title}
                        className="img-fluid mb-3 mx-auto d-block"
                        style={{
                          maxHeight: "120px",
                          objectFit: "contain",
                        }}
                      />
                    </div>

                    {/* Title */}
                    <div className="flex-grow-1">
                      <h5>{item.title}</h5>
                    </div>

                    {/* PDF Button */}
                    {item.attachments?.[0] ? (
                      <a
                        href={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-primary mt-2"
                      >
                        Show PDF
                      </a>
                    ) : (
                      <p className="text-danger mt-2">
                        No PDF Available
                      </p>
                    )}

                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <p>No magazines available for this year.</p>
              </div>
            )}
          </div>

        </div>
      </div>
    </>
  );
};

export default Magazine;